import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=5488a598&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=ts&"
export * from "./finish.vue?vue&type=script&lang=ts&"
import style0 from "./finish.vue?vue&type=style&index=0&id=5488a598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488a598",
  null
  
)

export default component.exports